import { useEffect, useState } from 'react'

/** Counts down once per second and stops at zero. Remount to reset. */
export function useOfferCountdown(durationSeconds: number): number {
  const [remaining, setRemaining] = useState(durationSeconds)
  const expired = remaining <= 0

  useEffect(() => {
    if (expired) return
    const intervalId = window.setInterval(() => {
      setRemaining(current => Math.max(0, current - 1))
    }, 1000)
    return () => window.clearInterval(intervalId)
  }, [expired])

  return remaining
}
